import { useAppData } from '../context/AppDataContext';

/**
 * useSubscription — now a thin wrapper around the global AppDataContext.
 *
 * Previously this hook independently fetched the subscription on every page
 * mount. Now it reads from the shared cache that's fetched once on login.
 *
 * API is unchanged so existing pages don't need modifications.
 */
export const useSubscription = () => {
  const {
    subscription,
    subLoading: loading,
    syncing,
    hasActiveSubscription,
    refreshSubscription,
    canAddSensors,
    canAddGateways,
    canAddZones,
    canUseAIAnalysis,
    canAccessDashboard,
    canUseVerifyReports,
    subscriptionRequired,
  } = useAppData();

  return {
    subscription,
    loading,
    syncing,
    hasActiveSubscription,
    refreshSubscription,
    // Helper methods (match the old API)
    canAddSensors,
    canAddGateways,
    canAddZones,
    canUseAIAnalysis,
    canAccessDashboard,
    canUseVerifyReports,
    subscriptionRequired,
  };
};

export default useSubscription;
